module.exports = __webpack_public_path__ + "static/media/10B.1766881d.jpg";